// MenuProdutividadeLink.jsx
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import StyledListItemButton from "./StyledListItemButton";

const MenuProdutividadeLink = ({ children }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Mesmo path, mas com "state" único por clique
    navigate("/produtividade", { state: { reset: Date.now() } });
  };

  return (
    <StyledListItemButton onClick={handleClick}>
      {children}
    </StyledListItemButton>
  );
};

MenuProdutividadeLink.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MenuProdutividadeLink;
